var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "input-group",
      class: ["generic-date-picker", _vm.containerClass, _vm.sizeClass],
    },
    [
      _c("input", {
        ref: "text",
        staticClass: "form-control",
        attrs: {
          type: "date",
          placeholder: _vm.placeholder,
          title: _vm.currentToolTip,
          readOnly: _vm.readOnly,
        },
        domProps: { value: _vm.text },
        on: {
          input: _vm.updateText,
          keyup: [
            function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
              )
                return null
              return _vm.showPicker($event)
            },
            function ($event) {
              return _vm.eventGeneric("keyup", $event)
            },
          ],
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "input-group-append mx-0 d-print-none" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-info",
            attrs: { title: "Max", type: "button" },
            on: { click: _vm.max },
          },
          [_c("i", { staticClass: "fas fa-arrow-right" })]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "input-group-append mx-0" },
        [
          _c("b-form-datepicker", {
            ref: "picker",
            class: [_vm.buttonClass, _vm.sizeClass],
            attrs: {
              value: _vm.currentDate,
              "button-only": "",
              "hide-header": "",
              "nav-button-variant": _vm.navVariant,
              right: "",
              locale: "en-US",
              "reset-button": "",
              "today-button": "",
              "close-button": "",
              "date-format-options": {
                year: "numeric",
                month: "numeric",
                day: "numeric",
              },
              "date-disabled-fn": _vm.dateDisabled,
            },
            on: {
              input: _vm.updateDate,
              hidden: _vm.pickerHidden,
              context: _vm.onContext,
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }